
<div class="modal-header" translate>Create from a template</div>
<div class="modal-body">
  <spinner *ngIf="!templates"></spinner>
  <entity-list *ngIf="templates" [entities]="templates" [filterKeys]="['name']" [sortEntityPaths]="['id']">
    <ng-template entityListEmpty>
      <empty-state icon="folders" [text]="'No templates created yet'|translate"></empty-state>
    </ng-template>
    <ng-template entityListItem let-template="entity">
      <div class="list-group-item list-group-item-action combi single no-wrap"><a class="list-group-main" (click)="selectTemplate(template)"><i class="far fa-fw fa-folder" *ngIf="template.file.isDir"></i><i class="far fa-fw fa-file" *ngIf="!template.file.isDir"></i>&nbsp; {{template.name}}</a>
        <button class="btn btn-link reveal" (click)="deleteTemplate(template)"><i class="far fa-trash-alt"><span class="sr-only" translate>Delete</span></i></button>
      </div>
    </ng-template>
  </entity-list>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="close()" translate>Close</button>
</div>